"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPhone = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconPhone = function IconPhone(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.382 13.382c-1.781 1.781-3.844 3.484-4.66 2.669-1.167-1.168-1.887-2.184-4.46-.116-2.573 2.069-.597 3.447.534 4.579 1.305 1.304 6.17.068 10.978-4.74s6.045-9.673 4.74-10.978c-1.132-1.131-2.51-3.107-4.579-.534-2.068 2.573-1.052 3.293.116 4.46.815.816-.888 2.878-2.669 4.66z"
  }));
};
exports.IconPhone = IconPhone;